import {useEffect, useState} from 'react';
import debounce from 'lodash/debounce';
const useIsMobile = (threshold = 992) => {
    const [width, setWidth] = useState(window.innerWidth);

    const handleWindowSizeChange = debounce(() => {
        setWidth(window.innerWidth);
    }, 300);

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, [handleWindowSizeChange]);

    return (width < threshold);
};
export default useIsMobile;